// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_etp from "./buhta_control_v1alpha1_etp.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetEtpRequest = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp_service.ml",
      509,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetEtpResponse = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp_service.ml",
      572,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEtpsRequest = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp_service.ml",
      632,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEtpsResponse = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_etp_service.ml",
      692,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.GetEtpRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetEtpRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetEtpRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEtpRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.control.v1alpha1.GetEtpResponse";
}

function make$1(etp, param) {
  return {
          etp: etp
        };
}

const $$let = Buhta_controlapis__Buhta_control_v1alpha1_etp.Buhta.Control.V1alpha1.Etp;

const merge_etp = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "etp",
            "etp"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          etp: Curry._2(merge_etp, t1.etp, t2.etp)
        };
}

function spec$1(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_etp.Buhta.Control.V1alpha1.Etp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "etp",
                    "etp"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.etp);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(etp) {
  return {
          etp: etp
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetEtpResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.etp);
  };
}

function constructor$3(etp) {
  return {
          etp: etp
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetEtpResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEtpResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.control.v1alpha1.ListEtpsRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.ListEtpsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.ListEtpsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEtpsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.control.v1alpha1.ListEtpsResponse";
}

function make$3(etpsOpt, param) {
  const etps = etpsOpt !== undefined ? etpsOpt : /* [] */0;
  return {
          etps: etps
        };
}

const $$let$2 = Buhta_controlapis__Buhta_control_v1alpha1_etp.Buhta.Control.V1alpha1.Etp;

const merge_etps = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "etps",
            "etps"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          etps: Curry._2(merge_etps, t1.etps, t2.etps)
        };
}

function spec$3(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_etp.Buhta.Control.V1alpha1.Etp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "etps",
                    "etps"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.etps);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(etps) {
  return {
          etps: etps
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.ListEtpsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.etps);
  };
}

function constructor$7(etps) {
  return {
          etps: etps
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.ListEtpsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEtpsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const getEtp_0 = {
  name: GetEtpRequest.name,
  make: GetEtpRequest.make,
  from_proto: GetEtpRequest.from_proto,
  from_proto_exn: GetEtpRequest.from_proto_exn,
  to_proto: GetEtpRequest.to_proto,
  to_proto$p: GetEtpRequest.to_proto$p,
  merge: GetEtpRequest.merge,
  to_json: GetEtpRequest.to_json,
  from_json_exn: GetEtpRequest.from_json_exn,
  from_json: GetEtpRequest.from_json
};

const getEtp_1 = {
  name: GetEtpResponse.name,
  make: GetEtpResponse.make,
  from_proto: GetEtpResponse.from_proto,
  from_proto_exn: GetEtpResponse.from_proto_exn,
  to_proto: GetEtpResponse.to_proto,
  to_proto$p: GetEtpResponse.to_proto$p,
  merge: GetEtpResponse.merge,
  to_json: GetEtpResponse.to_json,
  from_json_exn: GetEtpResponse.from_json_exn,
  from_json: GetEtpResponse.from_json
};

const getEtp = [
  getEtp_0,
  getEtp_1
];

const listEtps_0 = {
  name: ListEtpsRequest.name,
  make: ListEtpsRequest.make,
  from_proto: ListEtpsRequest.from_proto,
  from_proto_exn: ListEtpsRequest.from_proto_exn,
  to_proto: ListEtpsRequest.to_proto,
  to_proto$p: ListEtpsRequest.to_proto$p,
  merge: ListEtpsRequest.merge,
  to_json: ListEtpsRequest.to_json,
  from_json_exn: ListEtpsRequest.from_json_exn,
  from_json: ListEtpsRequest.from_json
};

const listEtps_1 = {
  name: ListEtpsResponse.name,
  make: ListEtpsResponse.make,
  from_proto: ListEtpsResponse.from_proto,
  from_proto_exn: ListEtpsResponse.from_proto_exn,
  to_proto: ListEtpsResponse.to_proto,
  to_proto$p: ListEtpsResponse.to_proto$p,
  merge: ListEtpsResponse.merge,
  to_json: ListEtpsResponse.to_json,
  from_json_exn: ListEtpsResponse.from_json_exn,
  from_json: ListEtpsResponse.from_json
};

const listEtps = [
  listEtps_0,
  listEtps_1
];

const V1alpha1_EtpService = {
  GetEtp: {
    name: "/buhta.control.v1alpha1.EtpService/GetEtp",
    package_name: "buhta.control.v1alpha1",
    service_name: "EtpService",
    method_name: "GetEtp",
    $$Request: {
      name: GetEtpRequest.name,
      make: GetEtpRequest.make,
      from_proto: GetEtpRequest.from_proto,
      from_proto_exn: GetEtpRequest.from_proto_exn,
      to_proto: GetEtpRequest.to_proto,
      to_proto$p: GetEtpRequest.to_proto$p,
      merge: GetEtpRequest.merge,
      to_json: GetEtpRequest.to_json,
      from_json_exn: GetEtpRequest.from_json_exn,
      from_json: GetEtpRequest.from_json
    },
    $$Response: {
      name: GetEtpResponse.name,
      make: GetEtpResponse.make,
      from_proto: GetEtpResponse.from_proto,
      from_proto_exn: GetEtpResponse.from_proto_exn,
      to_proto: GetEtpResponse.to_proto,
      to_proto$p: GetEtpResponse.to_proto$p,
      merge: GetEtpResponse.merge,
      to_json: GetEtpResponse.to_json,
      from_json_exn: GetEtpResponse.from_json_exn,
      from_json: GetEtpResponse.from_json
    }
  },
  getEtp: getEtp,
  ListEtps: {
    name: "/buhta.control.v1alpha1.EtpService/ListEtps",
    package_name: "buhta.control.v1alpha1",
    service_name: "EtpService",
    method_name: "ListEtps",
    $$Request: {
      name: ListEtpsRequest.name,
      make: ListEtpsRequest.make,
      from_proto: ListEtpsRequest.from_proto,
      from_proto_exn: ListEtpsRequest.from_proto_exn,
      to_proto: ListEtpsRequest.to_proto,
      to_proto$p: ListEtpsRequest.to_proto$p,
      merge: ListEtpsRequest.merge,
      to_json: ListEtpsRequest.to_json,
      from_json_exn: ListEtpsRequest.from_json_exn,
      from_json: ListEtpsRequest.from_json
    },
    $$Response: {
      name: ListEtpsResponse.name,
      make: ListEtpsResponse.make,
      from_proto: ListEtpsResponse.from_proto,
      from_proto_exn: ListEtpsResponse.from_proto_exn,
      to_proto: ListEtpsResponse.to_proto,
      to_proto$p: ListEtpsResponse.to_proto$p,
      merge: ListEtpsResponse.merge,
      to_json: ListEtpsResponse.to_json,
      from_json_exn: ListEtpsResponse.from_json_exn,
      from_json: ListEtpsResponse.from_json
    }
  },
  listEtps: listEtps
};

const V1alpha1 = {
  GetEtpRequest: GetEtpRequest,
  GetEtpResponse: GetEtpResponse,
  ListEtpsRequest: ListEtpsRequest,
  ListEtpsResponse: ListEtpsResponse,
  EtpService: V1alpha1_EtpService
};

const Control = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Control: Control
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetEtpRequest Not a pure module */
